<template>
  <div>
    <b-modal :ref="id" :id="id" :title="$t('workspace.delete-option.title')" scrollable size="lg" title-class="font-18" v-model="show" @hidden="onHide">
      <div>
        <b-alert show variant="primary">
          <span v-html="$t('workspace.delete-option.description', { workspace: workspace.name })"></span>
        </b-alert>

        <b-form-checkbox v-model="payload.moveOrganizations" switch class="mb-2"> {{ $t("workspace.delete-option.move-organizations") }}</b-form-checkbox>
        <b-form-checkbox v-model="payload.moveLibrary" switch class="mb-3"> {{ $t("workspace.delete-option.move-library") }}</b-form-checkbox>

        <div v-if="vuexStore == 'workspace' && (payload.moveOrganizations || payload.moveLibrary)">
          <multiselect
            v-model="payload.moveTo"
            track-by="_id"
            :placeholder="$t('workspace.my')"
            :options="workspaces"
            :searchable="false"
            :allow-empty="false"
            :show-labels="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <b><i class="mdi mdi-hexagon-multiple-outline font-size-20"></i> {{ option.name }} </b>
              </div>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b><i class="mdi mdi-hexagon-multiple-outline font-size-20"></i> {{ option.name }} </b>
            </template>
          </multiselect>

          <b-form-checkbox v-if="payload.moveOrganizations" v-model="payload.organizationOption.withAcl" switch class="mb-3 mt-3">
            {{ $t("workspace.delete-option.organization-option-with-acl") }}</b-form-checkbox
          >
        </div>

        <div v-else-if="vuexStore == 'managementWorkspace' && (payload.moveOrganizations || payload.moveLibrary)">
          <filter-select
            id="workspaceFilter"
            :selected="payload.moveTo"
            ref="workspaceFilter"
            :placeholder="$t('common.workspace')"
            :multiple="false"
            @filter="onWorkspaceChange"
            @changed="onWorkspaceSelect"
          />
        </div>
        <hr class="m-4" />
        <span v-html="$t('workspace.delete-option.repeat', { workspace: workspace.name })" class="text-danger"></span>

        <sweet-input v-model="repeat" :isValid="!$v.repeat.$error" @input="$v.repeat.$touch()" type="text" layout="vertical" inputClass="mb-1" />

        <sweet-button @click="remove()" :disabled="isDisabled" :loading="isUpdating" variant="danger" icon="mdi mdi-delete" :block="true">
          <span v-html="$t('workspace.delete-option.delete', { workspace: workspace.name })"></span>
        </sweet-button>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="ml-2">
            {{ $t("common.cancel") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { minLength, required, sameAs } from "vuelidate/lib/validators";
export default {
  props: { id: { required }, workspace: { required }, vuexStore: { required: false, default: "workspace" } },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10 },
        query: {},
      },

      payload: { moveTo: undefined, moveOrganizations: false, moveLibrary: false, organizationOption: { withAcl: false } },
      show: false,
      repeat: undefined,
    };
  },

  validations: {
    repeat: {
      required,
      sameAs: sameAs(function(value) {
        return this.workspace.name;
      }),
      minLength: minLength(1),
    },
  },
  computed: {
    workspaces() {
      return this.$store.getters[`${this.vuexStore}/pagination`].docs.filter((w) => this.workspace._id != w._id);
    },
    isLoading() {
      return this.$store.getters[`${this.vuexStore}/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`${this.vuexStore}/isUpdating`];
    },
    isDisabled() {
      return this.isLoading || this.$v.repeat.$error || ((this.payload.moveOrganizations || this.payload.moveLibrary) && !this.payload.moveTo);
    },
  },
  async mounted() {
    this.$v.$touch();
    await this.$store.dispatch("workspace/paginate");
  },
  methods: {
    async remove() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        this.payload.workspace = this.workspace;

        await this.$store.dispatch(`${this.vuexStore}/delete`, this.payload);

        this.$store.commit("switchWorkspace/selected", undefined);

        this.$toast.success("'" + this.$options.filters.translate(this.workspace.name) + "' " + this.$t("common.delete-successful"));
        this.$emit("onSuccess");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, {
          customMessage: "'" + this.$options.filters.translate(this.workspace.name) + "' " + this.$t("common.delete-fail"),
        });
      }
    },
    onHide() {
      this.payload = {};
      this.repeat = undefined;
      this.$emit("onHide");
    },
    onWorkspaceSelect(item) {
      if (item) {
        this.payload.moveTo = item;
      } else {
        this.payload.moveTo = undefined;
      }
    },
    async onWorkspaceChange(value, callback) {
      const response = await this.$store.dispatch(`managementWorkspace/workspaces`, {
        options: { limit: 10 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
  },
};
</script>
